import React from "react";
import { Chip, makeStyles } from "@material-ui/core";
import { blue } from "@material-ui/core/colors";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(() => ({
  chip: {
    marginLeft: 6,
    height: 20,
    backgroundColor: blue[600],
    color: "#fff",
    fontWeight: 600,
    fontSize: "0.7rem",
    "& .MuiChip-label": {
      paddingLeft: 6,
      paddingRight: 6
    }
  }
}));

const ScheduledBadge = ({ isScheduled, className }) => {
  const classes = useStyles();

  if (!isScheduled) {
    return null;
  }

  return (
    <Chip
      size="small"
      label={i18n.t("contacts.scheduledBadge")}
      className={className || classes.chip}
      component="span"
    />
  );
};

export default ScheduledBadge;
